import React, { useState, useEffect } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import YTMultiRepCard from "../../YTMultiRepCard.js";
import YTMustRefer from "../../YTMustRefer.js";
import YTClauseCard from "../../YTClauseCard.js";
import clauseData from "../../../data/Yukon/clauseData.js";
import clauseCardDesc from "../../../data/Yukon/clauseCardDescription.js";
import importantNotes from "../../../data/Ontario/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export default function YTPreConPurchase() {
  const [BuyerDocs, setBuyerDocs] = useState([
    "Consumer Relationships Guide",
    "Exclusive Buyer Representation Agreement",
    "Related FINTRAC Documents",
  ]);

  const [DealDocs, setDealDocs] = useState([
    "Purchase Contract (or Builder Sales Agreement)",
    "Addendums (if applicable)",
    "Copy of Deposit Cheque & Receipt",
  ]);

  const [BuyerRep, setBuyerRep] = useState("Client");
  const PreConReferralData = ["Builder Registration Form"];
  const [BuilderRep, setBuilderRep] = useState("YesNotMe");
  const [IsListed, setIsListed] = useState("Yes");
  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [IsMLS, setIsMLS] = useState("MLS");
  const [PropertyType, setPropertyType] = useState("Single Family");

  const SellerDocs = [
    "Consumer Relationships Guide",
    "Seller Customer Acknowledgement and Fee Agreement",
    "Seller Related FINTRAC Documents",
  ];

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const changeYTPurchaseType = (e) => {
    if (e.target.value === PropertyType) {
      return;
    } else if (e.target.value === "Single Family") {
      setPropertyType("Single Family");
      setDealDocs([
        "Residential Purchase Contract (or Builder Sales Agreement)",
        "Addendums (if applicable)",
        "Copy of Deposit",
      ]);
    } else if (e.target.value === "Condo") {
      setPropertyType("Condo");
      setDealDocs([
        "Residential Resale Condominium Property Purchase Contract (or Builder Sales Agreement)",
        "Addendums (if applicable)",
        "Copy of Deposit",
      ]);
    }
  };

  const addDisclosure = (e) => {
    setIsDisclosure(e.target.value);

    if (DealDocs.includes("Disclosure Requirements (see notes)") === true) {
      return;
    } else {
      setDealDocs([...DealDocs, "Disclosure Requirements (see notes)"]);
    }
  };

  const removeDisclosure = (e) => {
    setIsDisclosure(e.target.value);
    setDealDocs(
      DealDocs.filter((item) => item !== "Disclosure Requirements (see notes)")
    );
  };

  const setExclusive = () => {
    setIsMLS("Exclusive");
    if (DealDocs.includes("Land Title")) {
      return;
    } else {
      let newDocs = DealDocs.filter(
        (item) => item !== "MLS Sheet (Full Agent Detail View)"
      );
      newDocs.push("Land Title");
      setDealDocs(newDocs);
    }
  };

  const setMLS = () => {
    setIsMLS("MLS");
    if (DealDocs.includes("MLS Sheet (Full Agent Detail View)") === true) {
      return;
    } else {
      let newDocs = DealDocs.filter((item) => item !== "Land Title");
      newDocs.push("MLS Sheet (Full Agent Detail View)");
      setDealDocs(newDocs);
    }
  };

  const changeSellerRep = (e) => {
    setBuilderRep(e.target.value);
    setIsListed(e.target.value);

    if (e.target.value === "Referral") {
      setIsDisclosure("No");
      setDealDocs(
        DealDocs.filter(
          (item) => item !== "Disclosure Requirements (see notes)"
        )
      );
    }
    if (e.target.value === "No") {
      setDealDocs(
        DealDocs.filter((item) => item !== "MLS Sheet (Full Agent Detail View)")
      );
    }
    if (
      e.target.value === "Yes" ||
      (e.target.value === "YesNotMe" && IsMLS === "Exclusive")
    ) {
      if (DealDocs.includes("MLS Sheet (Full Agent Detail View)") === true) {
        return;
      } else {
        setDealDocs([...DealDocs, "MLS Sheet (Full Agent Detail View)"]);
      }
    }
    if (e.target.value !== "Yes") {
      setBuyerRep("Client");
      setBuyerDocs([
        "Consumer Relationships Guide",
        "Exclusive Buyer Representation Agreement",
        "Related FINTRAC Documents",
      ]);
    }
  };

  const changeBuyerRep = (e) => {
    setBuyerRep(e.target.value);
    if (e.target.value === "Client") {
      setBuyerDocs([
        "Consumer Relationships Guide",
        "Exclusive Buyer Representation Agreement",
        "Related FINTRAC Documents",
      ]);
    } else {
      setBuyerDocs([
        "Consumer Relationships Guide",
        "Customer Acknowlegement Form",
        "Related FINTRAC Documents",
      ]);
    }
  };

  const checkSelections = () => {
    let newDocs = [...DealDocs];

    if (IsMLS === "MLS") {
      newDocs.push("MLS Sheet (Full Agent Detail View)");

      if (IsDisclosure !== "No") {
        newDocs.push("Disclosure Requirements (see notes)");
      }
    } else if (IsMLS === "Exclusive") {
      newDocs.push("Land Title");

      if (IsDisclosure !== "No") {
        newDocs.push("Disclosure Requirements (see notes)");
      }
    } else {
      return;
    }

    setDealDocs(newDocs);
  };

  useEffect(() => {
    checkSelections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PropertyType]);

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <ThemeProvider theme={theme}>
            <FormControl sx={{ mt: 3, mb: 2, minWidth: 325, maxWidth: 110 }}>
              <InputLabel size="small" className="select-default-label">
                Property Type
              </InputLabel>
              <Select
                value={PropertyType}
                name="Property Type"
                label="Property Type"
                onChange={changeYTPurchaseType}
                size="small"
                sx={{ borderRadius: 20 }}
                defaultValue="Single Family"
              >
                <MenuItem key={Math.random()} value="Single Family">
                  Single Family
                </MenuItem>
                <MenuItem key={Math.random()} value="Condo">
                  Condo
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>
          <div className="pr-5 pt-3">
            Is the Builder Represented by an Agent?
          </div>

          <ThemeProvider theme={theme}>
            <FormControl sx={{ mt: 2, mb: 2, minWidth: 325, maxWidth: 325 }}>
              <InputLabel size="small" className="select-default-label">
                Builder Representation
              </InputLabel>
              <Select
                value={BuilderRep}
                name="Builder Representation"
                label="Builder Representation"
                onChange={changeSellerRep}
                size="small"
                sx={{ borderRadius: 20 }}
                defaultValue="YesNotMe"
              >
                <MenuItem key={Math.random()} value="YesNotMe">
                  Yes: by another Agent/Brokerage
                </MenuItem>
                <MenuItem key={Math.random()} value="Yes">
                  Yes: I represent the Builder
                </MenuItem>
                <MenuItem key={Math.random()} value="No">
                  No: I represent Buyer, Builder Unrepresented
                </MenuItem>
                <MenuItem key={Math.random()} value="Referral">
                  No: I am doing a Builder Referral
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>

          {BuilderRep === "Yes" ? (
            <>
              <div className="pr-5 pt-1">Buyer's Choice?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="Client"
                  >
                    <FormControlLabel
                      value="Client"
                      control={<Radio size="small" onClick={changeBuyerRep} />}
                      label="Client"
                    />
                    <FormControlLabel
                      value="Customer"
                      control={<Radio size="small" onClick={changeBuyerRep} />}
                      label="Customer Status"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}

          {IsListed !== "Referral" ? (
            <>
              {IsListed === "No" ? (
                ""
              ) : (
                <>
                  <div className="pr-5 pt-5">MLS or Exclusive Listing?</div>
                  <ThemeProvider theme={theme}>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        defaultValue={IsMLS}
                      >
                        <FormControlLabel
                          value="MLS"
                          control={<Radio size="small" onClick={setMLS} />}
                          label="MLS"
                        />
                        <FormControlLabel
                          value="Exclusive"
                          control={
                            <Radio size="small" onClick={setExclusive} />
                          }
                          label="Exclusive"
                        />
                      </RadioGroup>
                    </FormControl>
                  </ThemeProvider>
                </>
              )}
              <div className="pr-5 pt-5">
                {BuilderRep !== "Yes"
                  ? `Do you have any direct/indirect interest with respect to the Buyer in this transaction?`
                  : `Do you have any direct/indirect interest with respect to the Buyer or Seller in this transaction?`}
              </div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="No"
                  >
                    <FormControlLabel
                      value="Personal Trade"
                      control={<Radio size="small" onClick={addDisclosure} />}
                      label="Personal Trade"
                    />
                    <FormControlLabel
                      value="Indirect"
                      control={<Radio size="small" onClick={addDisclosure} />}
                      label="Indirect Interest"
                    />
                    <FormControlLabel
                      value="No"
                      control={
                        <Radio size="small" onClick={removeDisclosure} />
                      }
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
      {BuilderRep === "Yes" && IsDisclosure === "Indirect" ? (
        <>
          <div className="flex w-full pl-4 pt-3 items-center ">
            <div className="pb-5 pr-3">
              <div className="float-left mr-3 pt-2">
                <FontAwesomeIcon
                  icon={faTriangleExclamation}
                  size="2xl"
                  color="#cc0000"
                />
              </div>
              <div>
                Although it is not explicitly forbidden, it is strongly advised
                that you recommend to the Buyer that they seek representation
                with a different agent, as the potential conflict of interest
                may be too severe to ensure impartiality in this type of
                transaction.
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {BuilderRep === "YesNotMe" ? (
        <ChecklistCard
          province={"YT"}
          CheckListData={BuyerDocs}
          CheckListData2={DealDocs}
          Header={"Pre-Construction Purchase:"}
          Header2={"Buyer Client"}
          Title1="Buyer Representation Documents"
          Title2="Deal Documents"
        />
      ) : (
        ""
      )}
      {BuilderRep === "Yes" &&
      BuyerRep === "Client" &&
      IsDisclosure !== "Personal Trade" ? (
        <>
          <YTMultiRepCard />
          <ChecklistCard
            province={"YT"}
            CheckListData={BuyerDocs}
            CheckListData2={DealDocs}
            Header={"Pre-Construction Purchase:"}
            Header2={"Buyer Client"}
            Title1="Buyer Representation Documents"
            Title2="Deal Documents"
          />
        </>
      ) : (
        ""
      )}

      {BuilderRep === "Yes" && BuyerRep === "Customer" ? (
        <ChecklistCard
          province={"YT"}
          CheckListData={BuyerDocs}
          CheckListData2={DealDocs}
          Header={"Pre-Construction Purchase:"}
          Header2={"Buyer Customer Status"}
          Title1="Buyer Documents"
          Title2="Deal Documents"
        />
      ) : (
        ""
      )}

      {BuilderRep === "Yes" &&
      IsDisclosure === "Personal Trade" &&
      BuyerRep === "Client" ? (
        <YTMustRefer IsMLS={IsMLS} />
      ) : (
        ""
      )}

      {BuilderRep === "No" ? (
        <>
          <ChecklistCard
            province={"YT"}
            CheckListData={BuyerDocs}
            CheckListData2={SellerDocs}
            CheckListData3={DealDocs}
            Header={"Pre-Construction Purchase:"}
            Header2={"Buyer Client/Builder Unrepresented"}
            Title1="Buyer Representation Documents"
            Title2="Seller Documents"
            Title3="Deal Documents"
          />
        </>
      ) : (
        ""
      )}
      {IsListed === "Referral" ? (
        <ChecklistCard
          province={"YT"}
          CheckListData={PreConReferralData}
          Header={"Pre-Construction Purchase:"}
          Header2={"Builder Referral"}
          Title1="Deal Documents"
        />
      ) : (
        ""
      )}

      {BuilderRep === "Yes" &&
      IsDisclosure === "Personal Trade" &&
      BuyerRep === "Client" ? (
        ""
      ) : (
        <YTClauseCard
          ClauseCardDescription={clauseCardDesc.filter(
            (item) => item.category.includes("Single Family") === true
          )}
          ClauseDataCommon={clauseData.filter(
            (item) =>
              item.category.includes(PropertyType) === true &&
              item.isCommon === "yes"
          )}
          ClauseDataSituational={clauseData.filter(
            (item) =>
              item.category.includes(PropertyType) === true &&
              item.isCommon === "no"
          )}
        />
      )}
      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("precon") === true
          )}
        />

        {IsDisclosure === "Personal Trade" || IsDisclosure === "Indirect" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosurePurchase") === true
            )}
          />
        ) : (
          ""
        )}
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("purchase") === true
          )}
        />
      </div>
      <BackToTop />
    </div>
  );
}
